import React, {Component} from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Title from '../../common/title';

class Detail extends Component {
  state = {
    options: {
      credits: {
        enabled: false
      },
      chart: {
        type: 'column',
        height: 340
      },
      title: null,
      colors: this.props.chatColor,
      xAxis: {
        categories: [],
        crosshair: true
      },
      yAxis: {
        gridLineColor: 'rgba(61, 136, 241, 0.1)',
        title: null
      },
      legend: {
        itemStyle: {
          color: 'rgba(0, 0, 0, 0.65)',
          fontSize: 12,
          fontWeight: 'normal'
        },
        symbolWidth: 6,
        symbolHeight: 6,
      },
      plotOptions: {
        series: {
          borderRadiusTopLeft: 10,
          borderRadiusTopRight: 10
        },
        column: {
          pointWidth: 6,
          borderWidth: 0
        }
      },
      series: []
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.summary && nextProps.summary.histogram && this.state.options.series.length === 0) {
      const newHistogram = [];
      let index = null;
      if (nextProps.summary.histogram.categories && nextProps.summary.histogram.categories.length > 0) {
        for (let i = 0; i < nextProps.summary.histogram.categories.length; i++) {
          if (nextProps.summary.histogram.categories[i] === '注意力') {
            index = i;
          }
        }
      }
      for (let j = 0; j < nextProps.summary.histogram.series.length; j++) {
        newHistogram.push({
          name: `题目${j + 1}`,
          data: nextProps.summary.histogram.series[j].data.map((v, i) => {
            if (index !== i) {
              return v.score;
            }
          })
        });
      }
      this.setState({
        options: {
          xAxis: {
            categories: nextProps.summary.histogram.categories.filter(v => v !== '注意力')
          },
          series: newHistogram
        }
      });
    }
  }

  render() {
    const { options } = this.state;
    const { i18n, summary, themeColor } = this.props;

    return (
      <div className="mrg25">
        <Title iconfont="icon-lujing13572">{{title: i18n.result.summaryDetailTitle}}</Title>
        <div className="detailCon mgin60 mrgt16 borderBlack">
          <div className="summaryTitle">
            <i style={{backgroundColor: themeColor}} />
            <p>{i18n.result.emotionInfo}</p>
          </div>
          <div className="chatBox">
            <HighchartsReact
              highcharts={Highcharts}
              options={options}
            />
          </div>
          <div className="summaryTitle">
            <i style={{backgroundColor: themeColor}} />
            <p>{i18n.result.personalityInfo}</p>
          </div>
          <ul className="summaryList">
            {summary && summary.mbti && summary.mbti.characteristics && summary.mbti.characteristics.map((item, index) => (
              <li key={index}>
                <h1 style={{color: themeColor}}>{item.title}</h1>
                <p>{item.content}</p>
              </li>
            ))}
          </ul>
          <div className="summaryTitle">
            <i style={{backgroundColor: themeColor}} />
            <p>{i18n.result.characteristicsInfo.replace('${type}', summary.mbti && summary.mbti.mbtiType)}</p>
          </div>
          <ul className="summaryList">
            {summary && summary.mbti && summary.mbti.jobCharacteristics && summary.mbti.jobCharacteristics.map((item, index) => (
              <li key={index}>
                <h1 style={{color: themeColor}}>{item.title}</h1>
                <p>{item.content}</p>
              </li>
            ))}
          </ul>
          <div className="summaryTitle">
            <i style={{backgroundColor: themeColor}} />
            <p>{i18n.result.occupationInfo.replace('${type}', summary.mbti && summary.mbti.mbtiType)}</p>
          </div>
          <ul className="summaryList">
            {summary && summary.mbti && summary.mbti.occupations && summary.mbti.occupations.map((item, index) => (
              <li key={index}>
                <h1 style={{color: themeColor}}>{item.title}</h1>
                <p>{item.content}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default Detail;
